// import React from 'react';
// import { Modal, Box, Typography, Button, Grid } from '@mui/material';

// interface OrganisationModalProps {
//     open: boolean;
//     onClose: () => void;
//     organisation?: {
//         name?: string;
//         mobileNo?: string;
//         email?: string;
//         address?: string;
//         referenceName?: string;
//         referenceMobile?: string;
//         referenceEmail?: string;
//         category?: string;
//         comments?: string;
//     } | null;
// }

// const OrganisationModal: React.FC<OrganisationModalProps> = ({ open, onClose, organisation }) => {
//     return (
//         <Modal open={open} onClose={onClose}>
//             <Box
//                 sx={{
//                     position: 'absolute',
//                     top: '30%',
//                     left: '50%',
//                     transform: 'translate(-50%, -50%)',
//                     width: 400,  
//                     bgcolor: 'background.paper',
//                     p: 4,
//                     borderRadius: 1,
//                     boxShadow: 24,
//                 }}
//             >
//                 <Typography variant="h6" fontWeight="bold" gutterBottom>
//                     Organisation Details
//                 </Typography>
//                 <Grid container spacing={3}>
//                     <Grid item xs={6}>
//                         <Typography variant="body1" fontWeight="bold">
//                             Organisation Name:
//                         </Typography>
//                         <Typography variant="body1">
//                             {organisation?.name}
//                         </Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                         <Typography variant="body1" fontWeight="bold">
//                             Email Address:
//                         </Typography>
//                         <Typography variant="body1">
                          
//                         </Typography>
//                     </Grid>
//                 </Grid>
//                 <Grid container spacing={3}>
//                     <Grid item xs={6}>
//                         <Typography variant="body1" fontWeight="bold">
//                             Mobile No:
//                         </Typography>
//                         <Typography variant="body1">
                         
//                         </Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                         <Typography variant="body1" fontWeight="bold">
//                             Address:
//                         </Typography>
//                         <Typography variant="body1">
                           
//                         </Typography>
//                     </Grid>
//                 </Grid>
//                 <Grid container spacing={3}>
//                     <Grid item xs={6}>
//                         <Typography variant="body1" fontWeight="bold">
//                             Reference Name:
//                         </Typography>
//                         <Typography variant="body1">
                            
//                         </Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                         <Typography variant="body1" fontWeight="bold">
//                             Reference Mobile No:
//                         </Typography>
//                         <Typography variant="body1">
                           
//                         </Typography>
//                     </Grid>
//                 </Grid>
//                 <Grid container spacing={3}>
//                     <Grid item xs={6}>
//                         <Typography variant="body1" fontWeight="bold">
//                             Reference Email:
//                         </Typography>
//                         <Typography variant="body1">
                           
//                         </Typography>
//                     </Grid>
//                     <Grid item xs={6}>
//                         <Typography variant="body1" fontWeight="bold">
//                             Category:
//                         </Typography>
//                         <Typography variant="body1">
//                         {organisation?.category || "NA"}
//                         </Typography>
//                     </Grid>
//                 </Grid>
//                 <Grid container spacing={3}>
//                     <Grid item xs={12}>
//                         <Typography variant="body1" fontWeight="bold">
//                             Comments:
//                         </Typography>
//                         <Typography variant="body1">
                           
//                         </Typography>
//                     </Grid>
//                 </Grid>
//                 <Button
//                     onClick={onClose}
//                     variant="contained"
//                     color="primary"
//                     sx={{ mt: 3 }}
//                 >
//                     Close
//                 </Button>
//             </Box>
//         </Modal>
//     );
// };

// export default OrganisationModal;
import React from 'react';
import { Modal, Box, Typography, Button, Grid } from '@mui/material';

interface OrganisationModalProps {
    open: boolean;
    onClose: () => void;
    organisation?: {
        name?: string;
        mobileNo?: string;
        email?: string;
        address?: string;
        referenceName?: string;
        referenceMobile?: string;
        referenceEmail?: string;
        category?: string;
        comments?: string;
    } | null;
}

const OrganisationModal: React.FC<OrganisationModalProps> = ({ open, onClose, organisation }) => {
    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 500,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                }}
            >
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    Organisation Details
                </Typography>
                {organisation && (
                    <Box sx={{ mt: 2 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Typography variant="body1" fontWeight="bold">
                                    Organisation Name:
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {organisation.name || 'N/A'}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body1" fontWeight="bold">
                                    Email Address:
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {organisation.email || 'N/A'}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body1" fontWeight="bold">
                                    Mobile No:
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {organisation.mobileNo || 'N/A'}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body1" fontWeight="bold">
                                    Address:
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {organisation.address || 'N/A'}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body1" fontWeight="bold">
                                    Reference Name:
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {organisation.referenceName || 'N/A'}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body1" fontWeight="bold">
                                    Reference Mobile No:
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {organisation.referenceMobile || 'N/A'}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body1" fontWeight="bold">
                                    Reference Email:
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {organisation.referenceEmail || 'N/A'}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body1" fontWeight="bold">
                                    Category:
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {organisation.category || 'N/A'}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="body1" fontWeight="bold">
                                    Comments:
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {organisation.comments || 'N/A'}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                )}
                <Box sx={{ display: 'flex', justifyContent: 'right', mt: 3 }}>
                    <Button
                        onClick={onClose}
                        variant="contained"
                        color="primary"
                        sx={{ textTransform: 'none', fontWeight: 'bold', px: 4 }}
                    >
                        Close
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default OrganisationModal;
